/** @format */

import { useDispatch, useSelector } from 'react-redux';
import {
	useAppModalSelector,
	shareModalSelector,
	alertModalSeletor,
	extraMeetupModalSelector,
	profileModifyModalSelector,
	rightSidebarSelector
} from './selector';
import {
	toggleUseAppModal,
	toggleShareModal,
	toggleAlertModal,
	toggleExtraMeetupModal,
	toggleProfileModifyModal,
	toggleRightSidebar
} from './action';
import { useCallback } from 'react';

export const useModal = () => {
	const dispatch = useDispatch();
	const useAppModal = useSelector(useAppModalSelector);
	const alertModal = useSelector(alertModalSeletor);
	const shareModal = useSelector(shareModalSelector);
	const extraMeetupModal = useSelector(extraMeetupModalSelector);
	const profileModifyModal = useSelector(profileModifyModalSelector);
	const rightSidebar = useSelector(rightSidebarSelector);

	const boundToggleUseAppModal = useCallback(
		() => dispatch(toggleUseAppModal()),
		[dispatch]
	);

	const boundToggleAlertModal = useCallback(
		(toggle, type) => dispatch(toggleAlertModal(toggle, type)),
		[dispatch]
	);

	const boundToggleShareModal = useCallback(
		(toggle, copy = '') => dispatch(toggleShareModal(toggle, copy)),
		[dispatch]
	);

	const boundToggleExtraMeetupModal = useCallback(
		() => dispatch(toggleExtraMeetupModal()),
		[dispatch]
	);

	const boundToggleUseModifyModal = useCallback(
		() => dispatch(toggleProfileModifyModal()),
		[dispatch]
	);

	const boundToggleRightSidebar = useCallback(
		(toggle) => dispatch(toggleRightSidebar(toggle)),
		[dispatch]
	);

	return {
		shareModal,
		alertModal,
		useAppModal,
		extraMeetupModal,
		profileModifyModal,
		rightSidebar,
		boundToggleUseAppModal,
		boundToggleShareModal,
		boundToggleAlertModal,
		boundToggleExtraMeetupModal,
		boundToggleUseModifyModal,
		boundToggleRightSidebar
	};
};
